const GrassShader = {
    vertexShader: `
        attribute vec3 instancePosition;
        attribute float instanceRandom;

        uniform float time;
        uniform float bladeHeight;
        uniform float bladeWidth;

        varying float vHeightNorm;
        varying float vRandom;

        void main() {
            vHeightNorm = position.y;
            vRandom = instanceRandom;

            // Per-blade size variation — some tall, some short
            float heightMul = 0.35 + instanceRandom * 0.65;
            float widthMul = 0.5 + instanceRandom * 0.5;

            vec3 blade = vec3(
                position.x * bladeWidth * widthMul,
                position.y * bladeHeight * heightMul,
                0.0
            );

            // Wind sway — gentle, stronger at tip
            float tipFactor = position.y * position.y;
            float wind = sin(instancePosition.x * 0.3 + time * 1.8 + instanceRandom * 6.28) * 0.25
                       + sin(instancePosition.z * 0.25 + time * 1.3) * 0.18;
            blade.x += wind * tipFactor;
            blade.z += wind * 0.3 * tipFactor;

            // Random Y rotation
            float angle = instanceRandom * 6.2831853;
            float s = sin(angle);
            float c = cos(angle);
            vec3 rotated = vec3(
                blade.x * c - blade.z * s,
                blade.y,
                blade.x * s + blade.z * c
            );

            vec3 worldPos = rotated + instancePosition;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(worldPos, 1.0);
        }
    `,

    fragmentShader: `
        varying float vHeightNorm;
        varying float vRandom;

        void main() {
            // Rich gradient: dark base → bright tip
            vec3 baseColor = vec3(0.14, 0.38, 0.06);
            vec3 midColor = vec3(0.25, 0.55, 0.12);
            vec3 tipColor = vec3(0.45, 0.78, 0.20);

            vec3 color;
            if (vHeightNorm < 0.4) {
                color = mix(baseColor, midColor, vHeightNorm / 0.4);
            } else {
                color = mix(midColor, tipColor, (vHeightNorm - 0.4) / 0.6);
            }

            // Per-blade hue shift
            float shift = vRandom - 0.5;
            color.r += shift * 0.04;
            color.g += shift * 0.06;
            color.b += shift * 0.02;

            gl_FragColor = vec4(color, 1.0);
        }
    `
};

export default GrassShader;
